import { render } from "./TransactionListings.vue?vue&type=template&id=1a7ad42c&scoped=true"
import script from "./TransactionListings.vue?vue&type=script&lang=js"
export * from "./TransactionListings.vue?vue&type=script&lang=js"

import "./TransactionListings.vue?vue&type=style&index=0&id=1a7ad42c&scoped=true&lang=scss"

import exportComponent from "/home/lexmodo/Vue/FraudLabs/fraudlabs_vue/fraudlabs_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a7ad42c"]])

export default __exports__